import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import './EasyInput.css';

interface EasyInputProps {
  label: string;
  type: 0 | 1 | 2 | 3 | 4 | 5; // 0: 字符串, 1: 整数, 2: 小数, 3: 百分数, 4: 密码, 5: 手机号
  onChange: (value: string) => void;
  value: string;
  disabled?: boolean; // 是否禁用
  width?: string; // 宽度，默认100%
  height?: string; // 高度，默认35px
  areaCode?: string; // 区号
  onAreaCodeChange?: (code: string) => void; // 区号变化回调
  areaCodeOptions?: Array<{ code: string; dialCode: string; name: string; }>; // 区号选项
}

const EasyInput: React.FC<EasyInputProps> = ({
  label,
  type,
  onChange,
  value,
  disabled = false,
  width = '100%',
  height = '35px',
  areaCode = '+86',
  onAreaCodeChange,
  areaCodeOptions = []
}) => {
  const [inputValue, setInputValue] = useState(value);
  const [isFocused, setIsFocused] = useState(false);
  const [labelActive, setLabelActive] = useState(false);

  useEffect(() => {
    setInputValue(value);
    if (value || disabled) {
      setLabelActive(true);
    } else {
      setLabelActive(false);
    }
  }, [value, disabled]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;

    let val = e.target.value;

    if (type === 1) {
      val = val.replace(/[^0-9]/g, '');  // 整数
    } else if (type === 2) {
      val = val.replace(/[^0-9.]/g, ''); // 小数
    } else if (type === 3) {
      val = val.replace(/[^0-9.]/g, ''); // 百分数
    } else if (type === 5) {
      val = val.replace(/[^0-9]/g, '');  // 手机号
    }

    setInputValue(val);
    onChange(val);
  };

  const handleFocus = () => {
    if (!disabled) {
      setIsFocused(true);
      setLabelActive(true);
    }
  };

  const handleBlur = () => {
    if (!disabled) {
      setIsFocused(false);
      if (inputValue === '') {
        setLabelActive(false);
      }
    }
  };

  const handleLabelClick = () => {
    if (!disabled) {
      const inputElement = document.getElementById(`${label}-input`) as HTMLInputElement;
      if (inputElement) {
        inputElement.focus();
      }
    }
  };

  const handleAreaCodeChange = (value: string) => {
    onAreaCodeChange?.(value);
  };

  return (
    <div
      className={`easy-input-container ${isFocused ? 'focused' : ''} ${disabled ? 'disabled' : ''}`}
      style={{ width, height }}
    >
      <label
        className={`easy-input-label ${labelActive ? 'active' : ''}`}
        onClick={handleLabelClick}
      >
        {label}
      </label>
      <div className="input-wrapper">
        {type === 5 && areaCodeOptions.length > 0 ? (
          <Select
            value={areaCode}
            onChange={handleAreaCodeChange}
            className="custom-select"
            style={{ width: 100, marginRight: 8, zIndex: 1000 }}
            options={areaCodeOptions.map((option, index) => ({
              value: option.dialCode,
              label: option.dialCode,
              key: `${option.dialCode}-${index}`
            }))}
            virtual={false}
            placement="bottomLeft"
          />
        ) : type === 5 ? (
          <span className="phone-prefix">{areaCode}</span>
        ) : null}
        <input
          id={`${label}-input`}
          className="easy-input"
          autoComplete="off"
          type={
            type === 1 || type === 2 || type === 3 || type === 5 ? 'text' :
            type === 4 ? 'password' : 'text'
          }
          value={inputValue}
          onChange={handleInputChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={!labelActive ? label : ''}
          disabled={disabled}
          readOnly={disabled}
        />
      </div>
    </div>
  );
};

export default EasyInput;